import React from "react";

export const LazyProfilePage = React.lazy(() => import("pages/_private/ProfilePage"));
